/* REACT IMPORTS */
import React from "react";
import ReactDOM from "react-dom/client";

/* MATERIAL TAILWIND THEME PROVIDER */
import { ThemeProvider } from "@material-tailwind/react";

/* TOAST NOTIFICATION */
import { Toaster } from "react-hot-toast";

import { Provider } from "react-redux";

/* MAIN APPLICATION */
import Routes from "./routes/routes";

import store from "./redux/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <Routes />
        <Toaster
          position="top-right"
          reverseOrder={false}
          gutter={8}
          containerStyle={{}}
          toasterId="default"
          toastOptions={{
            className: "",
            duration: 5000,
            removeDelay: 1000,
            style: {
              fontFamily: "Source-Regular, sans-serif",
            },
          }}
        />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);
